import { put, takeLatest, fetch, apply, select, takeLeading, takeEvery } from '@ers/helpers/redux/sagaEffects';
import ApiFactory from '@ers/api/ApiFactory';
import { Message } from '@ers/data';
import { getMessageEdited } from './Messages.selectors';
import { ActionTypes, fetchAllThreadsCompleted, fetchMessagesFromThreadCompleted, sendMessageCompleted, fetchAttachmentCompleted, fetchThreadsUnreadCounterCompleted } from './Messages.actions';
import AppApi from '../App.api';

function* getAllThreads(api) {
    const response = yield fetch(api, api.fetchAllThreads);
    if (!(response.error)) {
        yield put(fetchAllThreadsCompleted(response.data));
    }
}
function* getThreadsUnreadCounter(api) {
    const response = yield fetch(api, api.fetchUnreadThreadsCounter);
    if (!(response.error)) {
        yield put(fetchThreadsUnreadCounterCompleted(response.data.counter));
    }
}

function* getMessagesFromThread(api, action) {
    const { threadId } = action.payload;
    const threadMessagesResponse = yield fetch(api, api.fetchMessagesFromThread, [threadId]);
    if (!(threadMessagesResponse.error)) {
        yield put(fetchMessagesFromThreadCompleted(threadId, threadMessagesResponse.data));
    }
}

function* markThreadAsRead(api, action) {
    const { threadId } = action.payload;
    yield fetch(api, api.markThreadAsRead, [threadId]);
}

function* sendMessage(api, action) {
    const { threadId } = action.payload;
    const message = new Message(yield select((state) => getMessageEdited(state, { threadId })));
    const sendMessageResponse = yield fetch(api, api.sendMessage, [threadId, message]);

    if (!(sendMessageResponse.error)) {
        yield put(sendMessageCompleted(threadId));
    }
}

function* fetchAttachment(api, action) {
    const { key } = action.payload;
    const [threadId, fileId] = key.split('_');
    const response = yield fetch(api, api.fetchFileFromThread, [threadId, fileId]);
    if (!response.error) {
        const actionCompleted = fetchAttachmentCompleted(threadId, fileId, response.data.blob);
        yield put(actionCompleted);
    }
}

export default function* messagesSaga() {
    const apiFactory = new ApiFactory();
    const api = yield apply(apiFactory, apiFactory.create);
    const appApi = new AppApi(api);
    yield takeLatest(ActionTypes.fetchAllThreads, getAllThreads, appApi);
    yield takeLatest(ActionTypes.fetchMessagesFromThread, getMessagesFromThread, appApi);
    yield takeLatest(ActionTypes.markThreadAsRead, markThreadAsRead, appApi);
    yield takeLeading(ActionTypes.sendMessage, sendMessage, appApi);
    yield takeEvery(ActionTypes.fetchAttachment, fetchAttachment, appApi);
    yield takeLatest(ActionTypes.fetchThreadsUnreadCounter, getThreadsUnreadCounter, appApi);
}